import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const formatDateTime = (dateTime) => {    
    const date = new Date(dateTime);
    if (date === "Invalid Date") {
      return "--";
    }
    const formattedDate = date.toISOString().slice(0, 19);
    const milliseconds = date.getMilliseconds();
    const formattedMilliseconds = (milliseconds / 1000).toFixed(2).slice(2);
    return `${formattedDate}.${formattedMilliseconds}`;
  };
const formatPrice = (value, decimalPlaces) => {
    if (value === null || value === undefined) return "";
    return Number(value).toFixed(decimalPlaces);
  };  

const defaultRender = (value) => (value ? value : "0.00");
const useHistoryCell = () => {
    const { t } = useTranslation();
    const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);


    return [
        { title: t("time"), dataIndex: 'dateTime', render: (value) => formatDateTime(value)  },
        { title: t("id"), dataIndex: 'ticket', render: defaultRender, },
        { title: t('openTicket'), dataIndex: 'openTicket', render: defaultRender, },
        { title: t('volume'), dataIndex: 'side', render: defaultRender, },
        { title: t('symbol'), dataIndex: 'symbolName', render: defaultRender, },
        { title: t('openPrice'), dataIndex: 'openPrice', render: (value) => formatPrice(value, decimalPlaces), },
        { title: t('closePrice'), dataIndex: 'closePrice', render: (value) => formatPrice(value, decimalPlaces), },
        { title: t('profit'), dataIndex: 'profitLoss', render: defaultRender, },
        { title: t('openCommission'), dataIndex: 'openCommissionValue', render: defaultRender, },
        { title: t('closeCommission'), dataIndex: 'closeCommissionValue', render: defaultRender, },
        { title: t("openAmount"), dataIndex: "amount", render: (value) => formatPrice(value, decimalPlaces) },
        { title: t("interest"), dataIndex: "interest", render: defaultRender },
        { title: t("comment"), dataIndex: "comment", render: defaultRender },
    ];
};

export default useHistoryCell;


